<template>
  <div class="about">
    <div class="container">
      <h1>关于我们</h1>
      
      <!-- 卡片式布局 -->
      <div class="about-cards">
        <!-- 公司简介卡片 -->
        <div class="about-card">
          <div class="card-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="card-title">公司简介</h2>
          <div class="card-content">
            <p>山东隆之智环保科技有限公司是一家专业从事环保检测服务、环保技术开发、环保科技咨询以及生态环境修复的综合性环保科技公司，由留学归国人员于2014年7月30日在淄博高新技术开发区注册成立。</p>
            <p>山东隆之智环保科技有限公司专业从事挥发性有机物（VOCs）控制服务,在引进并整合了当前全球先进VOCs控制经验和技术的基础上不断进行研发，为石油化工、煤化工、精细化工、氟化工、农药以及制药行业等提供更专业，省心的VOCs泄漏检测与修复（LDAR）、VOCs综合管控、污染源VOCs在线监测、VOCs废气回收治理、VOCs污染场地评估调查等一系列VOCs控制服务。隆之智环保愿与社会各界一道，在提升企业生产效能的同时为减少VOCs排放，为实现国家环境保护目标做出贡献。</p>
            <p>我们的团队拥有全方位的VOCs相关领域经验，熟悉各类化工装置和政策法规。隆之智在山东省，江苏省，河北省，河南省，辽宁省等多个省份已为众多不同级别不同行业的企业提供了完善的包括泄露检测与修复（LDAR）等VOCs控制服务。在为企业提供VOCs排放控制服务的同时，隆之智也为各地政府机构提供VOCs排放控制战略咨询服务，现已承担了多个省，市，县级环保部门VOCs项目的摸排调查工作。为主管部门制订规范标准和编撰政策性文件提供了依据和思路。</p>
          </div>
        </div>
        
        <!-- 企业文化卡片 -->
        <div class="about-card">
          <div class="card-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23 21V19C22.9993 18.1194 22.7172 17.265 22.1887 16.5637C21.6603 15.8624 20.9053 15.3606 20.03 15.11V8C20.03 6.12424 19.3441 4.31978 18.0711 2.92893C16.7981 1.53808 14.9937 0.75 13.12 0.75C11.2463 0.75 9.44186 1.53808 8.16882 2.92893C6.89578 4.31978 6.21 6.12424 6.21 8V13" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="card-title">企业文化</h2>
          <div class="card-content">
            <ul class="culture-list">
              <li><strong>司训：</strong>厚道谦恭  诚实信用  知恩感恩</li>
              <li><strong>经营宗旨：</strong>为客户提供一流服务
                 为社会创造最大价值
                 为员工提供创业平台</li>
              <li><strong>职业素养：</strong>专注细节  追求完美</li>
              <li><strong>服务要求：</strong>超越客户预期</li>
              <li><strong>职业守则：</strong>忠诚担当  爱岗敬业  专注执着 
                 包容奉献  团结拼搏  勤俭节约</li>
              <li><strong>工作方法：</strong>问题导向  发现问题  分析问题  解决问题</li>
              <li><strong>工作要求：</strong>结果导向  目标明确  方法科学  优质高效   超越预期</li>
              <li><strong>工作方式：</strong>钉“钉子”</li>
              <li><strong>动力源泉：</strong>居安思危  自我否定  自我清零  永久创业</li>
              <li><strong>管理准则：</strong>以制度规范人  以教育塑造人</li>
            </ul>
          </div>
        </div>
        
        <!-- 使命与愿景卡片 -->
        <div class="about-card">
          <div class="card-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 6V12L16 14" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="card-title">使命与愿景</h2>
          <div class="card-content">
            <div class="mission-vision">
              <div class="mission">
                <h3>我们的使命</h3>
                <p>公司致力于成为极为社会责任感的企业公民，以“创新环保科技，服务生态文明”为使命，恪守“为客户提供一流服务，为社会创造社会价值，为员工提供创业平台”的经营宗旨，坚持“诚信敬业、创新跨越”的发展理念，秉持“持续提供超越客户期望的产品与服务，做客户永远的伙伴”的服务理念和“专注细节，追求完美”的职业素养。志同道合便能引其类，公司现聚集了一批献身环保科技事业，具有绿色环保情怀的青年科技人员，有博士研究生2名，硕士研究生4名，本科生22名，涵盖环保、化工及资环等多个专业。</p>
              </div>
              <div class="vision">
                <h3>我们的愿景</h3>
                <p>山东隆之智环保科技有限公司是一家崭新的公司，它犹如一个新生命沐浴着全社会倡导绿色环保的春风来到这个世界，它身上已深深烙上绿色环保这一时代印记；它生逢其时，志存高远，具有顽强的生命力和强烈的使命感，它奉“厚道谦恭，诚实信用，知恩感恩”为司训，在坎坷崎岖的成长道路上，它将时刻以其座铭“正视自我，坦诚不足，勇于挑战，奋发图强”警戒自己； 它渴望阳光的照耀和雨露的滋润，您的每一次关注理解、呵护和支持， 都会铭刻心中。坚信公司在您的关怀帮助之下，全体伙伴努力践行公司文化，坚守情怀，不忘初心，砥砺前行，一定会实现环保人“让天空更蔚蓝，让山河更碧绿，让空气更清新，让家园更怡人”的梦想。</p>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 资质荣誉卡片 -->
        <div class="about-card">
          <div class="card-icon">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="7" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 16L12 22" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 22L12 18L16 22" stroke="#42b983" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="card-title">资质荣誉</h2>
          <div class="card-content">
            <div class="certifications-grid">
              <div class="cert-item">中华环保联合会VOCs污染防治专业委员会副主任委员单位</div>
              <div class="cert-item">中华环保联合会理事单位</div>
              <div class="cert-item">CMA资质认定证书</div>
              <div class="cert-item">计算机软件著作权证书</div>
              <div class="cert-item">质量管理体系认证证书</div>
              <div class="cert-item">环境管理体系认证证书</div>
              <div class="cert-item">职业健康安全管理体系认证证书</div>
              <div class="cert-item">校准证书LIEPT-YQ-H9CB5</div>
              <div class="cert-item">校准证书LIEPT-YQ-E130C</div>
              <div class="cert-item">校准证书LIEPT-YQ-E130F</div>
              <div class="cert-item">校准证书LTEPT-YQ-E1615</div>
              <div class="cert-item">校准证书LIEPT-YQ-E1627</div>
              <div class="cert-item">校准证书LIEPT-YQ-H4EFA</div>
              <div class="cert-item">校准证书LIEPT-YQ-H9A5D</div>
              <div class="cert-item">校准证书LIEPT-YQ-H9A5E</div>
              <div class="cert-item">校准证书LIEPT-YQ-HA485</div>
              <div class="cert-item">校准证书LIEPT-YQ-HA1CA</div>
              <div class="cert-item">校准证书LIEPT-YQ-H7609</div>
              <div class="cert-item">校准证书LIEPT-YQ-H7286</div>
              <div class="cert-item">校准证书LIEPT-YQ-H760A</div>
              <div class="cert-item">校准证书LIEPT-YQ-H559E</div>
              <div class="cert-item">校准证书LIEPT-YQ-H559D</div>
              <div class="cert-item">校准证书LIEPT-YQ-H78C5</div>
              <div class="cert-item">校准证书LIEPT-YQ-H50ED</div>
              <div class="cert-item">校准证书LIEPT-YQ-H9F72</div>
              <div class="cert-item">校准证书LIEPT-YQ-H9CB6</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppAbout'
}
</script>

<style scoped>
.about {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

 h1 {
  font-size: 36px;
  margin-bottom: 50px;
  color: #333;
  text-align: center;
}

@media screen and (max-width: 768px) {
  .about {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 480px) {
  .about {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
    margin-bottom: 30px;
  }
}

/* 卡片容器 */
.about-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  justify-items: center;
}

/* 卡片样式 */
.about-card {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
  transition: all 0.3s ease;
  text-align: center;
  max-width: 1200px;
  width: 100%;
}

.about-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* 卡片图标 */
.card-icon {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-icon svg {
  max-width: 100%;
  height: auto;
  color: #42b983;
}

/* 卡片标题 */
.card-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
  font-weight: 600;
}

/* 卡片内容 */
.card-content {
  text-align: left;
}

.card-content p {
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
  line-height: 1.6;
}

/* 企业文化列表 */
.culture-list {
  list-style-type: none;
  padding: 0;
  margin: 15px 0;
}

.culture-list li {
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
  line-height: 1.6;
}

.culture-list li::before {
  content: "•";
  color: #42b983;
  font-weight: bold;
  position: absolute;
  left: 0;
}

/* 使命愿景 */
.mission-vision {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.mission h3,
.vision h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
  font-weight: 600;
}

/* 资质荣誉 */
.about-card:nth-child(4) .card-content {
  text-align: center;
}

.certifications-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 20px;
  justify-content: center;
}

.cert-item {
  background-color: #f8f9fa;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 15px;
  color: #333;
  transition: all 0.3s ease;
  text-align: center;
  border: 1px solid #e9ecef;
}

.cert-item:hover {
  background-color: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-color: #42b983;
  color: #42b983;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .about-cards {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .about-card {
    padding: 25px;
    max-width: 100%;
  }

  .card-title {
    font-size: 22px;
    margin-bottom: 18px;
  }

  .card-content p {
    font-size: 15px;
  }

  .culture-list li {
    font-size: 15px;
  }
}

@media screen and (max-width: 480px) {
  .about-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .about-card {
    padding: 20px;
  }

  .card-title {
    font-size: 20px;
    margin-bottom: 15px;
  }

  .card-content p {
    font-size: 14px;
  }

  .culture-list li {
    font-size: 14px;
  }

  .mission h3,
  .vision h3 {
    font-size: 18px;
  }

  .certification-item {
    padding: 12px;
    gap: 12px;
  }

  .cert-info h3 {
    font-size: 15px;
  }

  .cert-info p {
    font-size: 13px;
  }
}
</style>